export function removeField(object: any, field: string): any {
    if (object !== null && object !== undefined && typeof object === 'object') {
        const obj = { ...object };
        delete obj[field];
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === 'object') {
                if (Array.isArray(obj[key])) {
                    obj[key] = obj[key].map((it: any) => removeField(it, field));
                } else {
                    obj[key] = removeField(obj[key], field);
                }
            }
        });

        return obj;
    }

    return object;
}

export function removeTypename(object: any): any {
    if (object) {
        return removeField(object, '__typename');
    }

    return object;
}
